<template>
  <div
    v-loading="!menuList.length"
    class="nav-menu-vertical flex-column"
    :class="[theme, collapse]"
  >
    <div class="aside-header flex-row flex-item">
      <img class="aside-logo-img" :src="images.logo" alt="" />
      <span v-if="collapse === 'expand'" class="aside-logo-text">IoT数据应用中台</span>
    </div>
    <template v-for="(item, index) in menuArray">
      <div
        class="nav-menu-item"
        :tabindex="item.id"
        :key="item.id"
        @click="selectItem(item)"
        @mouseleave="handMouseleave({ parentIds: [] })"
        @mouseenter="handleCollapseHover(item)"
        :class="{
          'child-active': item.childActive,
          active: item.active,
          'first-level': !item.level,
        }"
        v-if="!item.hide"
        :style="itemStyle(item, index)"
      >
        <div
          @click.stop="() => {}"
          class="nav-menu-content parent-name"
          v-if="item.firsrChild && collapse === 'collapse'"
        >
          {{ menuArray[index - 1].title }}
        </div>
        <el-tooltip
          v-if="
            collapse === 'collapse' &&
            !item.level &&
            !(item.children && item.children.length)
          "
          :effect="theme"
          :content="item.title"
          placement="right"
        >
          <div
            style="position: relative; z-index: 999"
            class="nav-menu-content flex-row flex-item"
          >
            <i class="menu-icon" :class="item.icon"></i>
          </div>
        </el-tooltip>
        <div v-else class="nav-menu-content flex-row flex-item">
          <i class="menu-icon" :class="item.icon"></i>
          <div class="title text-ellipsis flex1">{{ item.title }}</div>
          <i
            v-if="item.children && item.children.length"
            class="menu-icon newhope-iconfont icon-base-right"
            :class="{
              'expand-status-icon': item.expand && collapse === 'expand',
            }"
          ></i>
        </div>
        <div class="nav-item-bg"></div>
      </div>
    </template>

    <!-- 底部用户信息区 -->
    <div class="aside-user-footer">
      <!-- 展开状态 -->
      <div v-if="collapse === 'expand'" class="user-block-expand"
           @mouseenter="showLogoutBtn = true"
           @mouseleave="showLogoutBtn = false">
        <transition name="logout-fade">
          <div v-show="showLogoutBtn" class="logout-btn" @click="loginOut">
            <svg class="logout-icon" viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg"><path d="M832 500.6208c0 13.056-5.76 24.8768-14.8352 32.9856l-148.0768 132.896c-7.8976 7.0016-18.3488 11.264-29.7472 11.264-24.6016 0-44.5248-19.7888-44.5248-44.2496 0-13.1968 5.76-24.8768 14.8352-32.9792l62.048-55.6544L472.5632 544.8832c-24.5248 0-44.3904-19.7888-44.3904-44.3904 0-24.4608 19.8656-44.2496 44.3904-44.2496l199.136 0-62.048-55.6544c-9.0752-8.1088-14.8352-19.8592-14.8352-32.9792 0-24.4608 19.9232-44.256 44.5248-44.256 11.3984 0 21.8496 4.2624 29.7472 11.4048l148.0768 132.8896C826.24 475.7504 832 487.5712 832 500.6208M406.0096 216.64 280.8384 216.64l0 590.7264 125.1712 0c24.5312 0 44.3904 19.9232 44.3904 44.3904 0 24.6016-19.9296 44.2496-44.3904 44.2496L236.4544 896.0064c-24.5248 0-44.448-19.648-44.448-44.2496L192.0064 172.32C192 147.8592 211.9296 128 236.4544 128l169.5552 0c24.4544 0 44.3904 19.8592 44.3904 44.32C450.4 196.7808 430.5408 216.64 406.0096 216.64" fill="currentColor"/></svg>
            <span>退出登录</span>
          </div>
        </transition>
        <div class="user-profile flex-row flex-item">
          <div class="user-avatar-circle">
            <img v-if="baseInfo.avatar" :src="baseInfo.avatar" class="user-avatar-img" />
            <span v-else>{{ avatarText }}</span>
          </div>
          <div class="user-text">
            <div class="user-name">{{ baseInfo.name || '用户' }}</div>
            <div class="user-dept">{{ baseInfo.departmentName || '' }}</div>
          </div>
          <div class="user-more">
            <span class="more-dots">···</span>
          </div>
        </div>
      </div>
      <!-- 收起状态：仅退出按钮 -->
      <el-tooltip
        v-else
        content="退出登录"
        placement="right"
        :effect="theme"
      >
        <div class="user-info-collapse" @click="loginOut">
          <i class="el-icon-switch-button"></i>
        </div>
      </el-tooltip>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { getStorage, setStorage } from '@utils/storage';
import { apiBase } from '../../../../config';

const images = {
  logo: require('@/assets/imgs/logo.svg'),
};

export default {
  name: 'navMenu',
  data() {
    return {
      images,
      theme: 'light',
      menuArray: [],
      inited: false,
      leaveHandleTimer: null,
      enterHandleTimer: null,
      showLogoutBtn: false,
    };
  },
  methods: {
    ...mapActions('systemMenu', ['doSwitchTab']),
    loginOut() {
      const url = `${apiBase}auth/logout`;
      location.href = url;
    },
    handleExpandClick(item) {
      if (item.expand) {
        this.menuArray = this.menuArray.map((menu) => {
          if (item.id === menu.id || item.allChildren.includes(menu.id)) {
            menu.expand = false;
          }
          return {
            ...menu,
          };
        });
      } else {
        item.expand = true;
      }
    },
    selectItem(item) {
      if (!item.id) {
        return;
      }
      if (item.path && this.$route.path !== item.path) {
        this.$router.push({
          path: item.path,
        });
      } else {
        this.activeItem(item);
      }
    },
    activeItem(item) {
      if (this.collapse === 'expand') {
        this.handleExpandClick(item);
      } else if (item.path) {
        // 如果页面跳转收起菜单
        this.clearHoverExpand();
      }
      this.menuArray = [...this.menuArray].map((menu) => {
        const active = item.id === menu.id || item.pid === menu.id;
        // 点击没有path的菜单之前active的菜单转为childActive
        const childActive =
          menu.allChildren.includes(this.activeTab.id) ||
          (!item.path && this.activeTab.id === menu.id);
        return {
          ...menu,
          active,
          childActive: childActive && !active,
        };
      });
    },
    clearHoverExpand() {
      this.menuArray = this.menuArray.map((menu) => {
        return {
          ...menu,
          expand: false,
        };
      });
    },
    handMouseleave(item) {
      this.leaveHandleTimer = setTimeout(() => {
        this.handleCollapseHover(item);
      }, 200);
    },
    handleCollapseHover(item) {
      clearTimeout(this.leaveHandleTimer);
      clearTimeout(this.enterHandleTimer);
      if (this.collapse === 'expand') {
        return;
      }
      this.enterHandleTimer = setTimeout(() => {
        if (!item || !item.id) {
          this.clearHoverExpand();
          return;
        }
        const nextLevelId = (item.children || []).map((child) => {
          return child.id;
        });
        const brothers = this.menuArray
          .filter((menu) => {
            return (
              (item.parentIds || []).join(',') ===
              (menu.parentIds || []).join(',')
            );
          })
          .map((menu) => {
            return menu.id;
          });
        const parentsItems = this.menuArray.filter((menu) => {
          return (item.parentIds || []).includes(menu.id);
        });
        const parentsBrothers = this.menuArray
          .filter((menu) => {
            return parentsItems.some((parent) => {
              return (
                (parent.parentIds || []).join(',') ===
                (menu.parentIds || []).join(',')
              );
            });
          })
          .map((menu) => {
            return menu.id;
          });
        this.menuArray = this.menuArray.map((menu) => {
          return {
            ...menu,
            expand: [
              ...nextLevelId,
              ...(item.parentIds || []),
              ...parentsBrothers,
              ...brothers,
            ].includes(menu.id),
          };
        });
      }, 100);
    },
    themeSwitch() {
      this.theme = this.theme === 'dark' ? 'light' : 'dark';
      setStorage('nav-menu-theme', this.theme);
    },
    expandInit() {
      const activeTab = this.menuArray.find((item) => {
        return item.path === this.$route.path;
      });
      if (this.collapse === 'collapse') {
        this.clearHoverExpand();
      } else if (activeTab && activeTab.parentIds) {
        // 展开父级
        this.menuArray = this.menuArray.map((menu) => {
          return {
            ...menu,
            expand:
              activeTab.parentIds.includes(menu.id) || activeTab.id === menu.id,
          };
        });
      }
    },
    itemStyle(item, index) {
      let backgroundColor = ['#001529', '#14161A', '#0b0b0c'];
      let defaultColor = '#0b0b0c';
      if (this.theme === 'light') {
        backgroundColor = ['#f5f5f5', '#f5f5f5', '#f5f5f5'];
      }
      defaultColor = '#ffffff';
      let height = '0';
      if (this.expandList.includes(item.id) || !item.level) {
        height = '40px';
      }
      if (this.collapse === 'expand') {
        return {
          paddingLeft: `${item.level * 16}px`,
          height,
          background: backgroundColor[item.level] || defaultColor,
          overflow: 'hidden',
        };
      } else {
        return {
          display:
            this.expandList.includes(item.id) || !item.level ? 'block' : 'none',
          background: backgroundColor[item.level] || defaultColor,
          left: `${item.left}px`,
          top: `${item.top}px`,
          zIndex: `${item.level * 2000 + index}`,
        };
      }
    },
    treeToArry(menus) {
      const array = [];
      const doLoop = (tree, level, parentIds, top) => {
        const list = tree.filter((i) => {
          return !i.hide;
        });
        list.forEach((item, index) => {
          const parentTop = top + 40 * (index + (level === 1 ? 1 : 0));
          array.push({
            ...item,
            level,
            parentIds,
            left: level * 240 - (level ? 200 : 0),
            top: parentTop,
            firsrChild: level === 1 && !index,
          });
          if (item.children && item.children.length) {
            doLoop(
              item.children,
              level + 1,
              [...parentIds, item.id],
              parentTop
            );
          }
        });
      };
      doLoop(menus, 0, [], 48);
      return array;
    },
    init() {
      if (this.inited) {
        return;
      }
      const path = this.$route.path;
      let targetPage = this.menuArray.find((item) => {
        return path === item.path;
      });
      if (!targetPage) {
        targetPage = this.tabList.find((item) => {
          return item.path === path;
        });
      }
      if (targetPage) {
        this.expandInit();
        this.selectItem(targetPage);
        this.inited = true;
      }
    },
  },
  mounted() {
    this.theme = getStorage('nav-menu-theme') || 'light';
    // 从本地存储初始化菜单折叠状态到 Vuex
    const storedCollapse = getStorage('nav-menu-collapse') || 'expand';
    this.$store.commit('systemMenu/updateMenuCollapse', storedCollapse);
  },
  computed: {
    ...mapState('systemMenu', ['menuList', 'activeTab', 'tabList', 'menuCollapse']),
    ...mapState('userInfo', ['baseInfo']),
    avatarText() {
      const name = this.baseInfo.name || '';
      return name.length >= 2 ? name.slice(-2) : name || '用';
    },
    collapse() {
      return this.menuCollapse;
    },
    expandList() {
      return this.menuArray.reduce((pre, item) => {
        const firstLevel = item.level ? [] : [item.id];
        if (item.expand) {
          let nextLevelId = [];
          if (this.collapse === 'expand') {
            // 折叠菜单的子集自身有expand
            nextLevelId = (item.children || []).map((child) => {
              return child.id;
            });
          }
          return [...pre, item.id, ...nextLevelId, ...firstLevel];
        } else {
          return [...pre, ...firstLevel];
        }
      }, []);
    },
  },
  watch: {
    menuList: {
      handler(N) {
        // console.log('N', N);
        const list = this.treeToArry(N || []);
        this.menuArray = list.map((item) => {
          return {
            ...item,
            allChildren: list
              .filter((child) => {
                return child.parentIds.includes(item.id);
              })
              .map((child) => {
                return child.id;
              }),
          };
        });
        if (list.length) {
          this.init();
        }
      },
      immediate: true,
      deep: true,
    },
    $route: {
      handler(N) {
        const active = this.menuArray.find((item) => {
          return item.path && item.path === N.path;
        });
        if (active) {
          this.activeItem(active);
          this.doSwitchTab(active);
        }
      },
      immediate: true,
      deep: true,
    },
    menuCollapse(newVal) {
      this.expandInit();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./expand";
@import "./collapse";
@import "./dark";
@import "./light";
</style>

<style lang="scss">
.logout-fade-enter-active,
.logout-fade-leave-active {
  transition: opacity 0.2s ease, max-height 0.2s ease, margin 0.2s ease;
  overflow: hidden;
  max-height: 42px;
}
.logout-fade-enter,
.logout-fade-leave-to {
  opacity: 0;
  max-height: 0;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}
</style>
